import React, { useEffect, useState } from 'react'
import { Container, Row, Col, Form, Button, Card, OverlayTrigger, Tooltip, Modal } from 'react-bootstrap'
import { useTranslation } from "react-i18next"
import useAuth from '../../context/auth/useAuth'
import { useDispatch, useSelector } from 'react-redux'
import { changeIdealPositionTypeStatus, editIdealPositionTeacher, getCandidate, getCandidateAvailableLevels, getCandidateAvailableSubjectsByCourses, getCandidateProfileStatus } from '../../actions/candidatesActions'
import Swal from 'sweetalert2'
import Select from "react-select"
import Loading from '../../components/design/Modal/Loading'
import { getCandidateAvailableTowns, getCandidateProvinces, getCourseSubjects } from '../../actions/miscellaneousActions'
import { useParams } from 'react-router-dom'

export default function IdealPosition() {
	const {id: candidateId} = useParams() || {}
	const { t } = useTranslation()
	const {client} = useAuth()
	const dispatch = useDispatch()

	const {candidate, resultcandidate, loading, levels, subjects} = useSelector(state=>state.candidates)
	const {loading: miscellaneousLoading, towns, provinces, subjects: allSubjects} = useSelector(state => state.miscellaneous)

	const [teacherFormState, setTeacherFormState] = useState({
		minWage: null,
		movilityAvailability: null,
		desiredLocations: [],
		subjects: [],
		specialities: [],
		workDay: []
	})

	const [activeType, setActiveType] = useState(null)

	const [locationOptions, setLocationOptions] = useState([])

	const handleSubmit = (e) => {
		e.preventDefault()

		if (!teacherFormState.movilityAvailability || teacherFormState.specialities.length === 0 || teacherFormState.subjects.length === 0 || teacherFormState.workDay.length === 0 || (teacherFormState.movilityAvailability.value !== 'local' && teacherFormState.desiredLocations.length === 0)) {
			Swal.fire({
				icon: 'error',
				showConfirmButton: true,
				text: t('profile.candidate.idealPosition.formNotCompleted')
			})
		} else {
			let movilityAvailability = teacherFormState?.movilityAvailability?.value
			let desiredLocations = teacherFormState?.desiredLocations.map(location => {return location?.value})
			let subjects = teacherFormState?.subjects?.map(subject => {return subject?.value})
			let specialities = teacherFormState?.specialities?.map(speciality => {return speciality?.value})
			let workDay = teacherFormState?.workDay?.map(workDay => {return workDay?.value})

			dispatch(editIdealPositionTeacher(candidateId || client?.id, {...teacherFormState, movilityAvailability, desiredLocations, subjects, specialities, workDay, type: activeType}))
		}
	}

	const changeSpecialities = (selectedValues) => {
		if (selectedValues.length > 0) {
			setTeacherFormState({
				...teacherFormState,
				specialities: selectedValues,
				subjects: teacherFormState?.subjects?.filter(subject => selectedValues.find(value => value?.value === subject?.level) ? true : false)
			})
			dispatch(getCandidateAvailableSubjectsByCourses(candidateId || client?.id, selectedValues?.map(value => {
				return value?.value
			})))
		} else {
			dispatch({ type: 'CANDIDATE_RESET_SUBJECTS' })
			setTeacherFormState({...teacherFormState, specialities: selectedValues, subjects: []})
		}
	}

	const changeSubjects = (selectedValues) => {
		if (selectedValues?.length < 4) {
			setTeacherFormState({ ...teacherFormState, subjects: selectedValues })
		} else {
			Swal.fire({
				icon: 'warning',
				text: t('profile.candidate.idealPosition.maxSubjectsSelected'),
				showConfirmButton: true
			})
		}
	}

	const handleActiveSwitch = (value, type) => {
		dispatch(changeIdealPositionTypeStatus(candidateId || client?.id, {
			function: 'teacher',
			type: type,
			active: value
		}))
	}

	const selectType = async (type) => {
		let desiredLocations = []
		let subjects = []
		let specialities = []

		if (candidate?.idealPositions && candidate?.idealPositions?.teacher[type]) {
			if (candidate?.idealPositions?.teacher[type]?.desiredLocations) {
				for await(const location of candidate?.idealPositions?.teacher[type]?.desiredLocations) {
					let locationValue = null
					if (candidate?.idealPositions?.teacher[type]?.movilityAvailability === 'autonomous' || candidate?.idealPositions?.teacher[type]?.movilityAvailability === 'national') {
						locationValue = provinces.find(p => p.value === location)
					} else {
						locationValue = towns.find(t => t.value === location)
					}

					if (locationValue) {
						desiredLocations?.push(locationValue)
					}
				}
			}

			if (candidate?.idealPositions?.teacher[type]?.subjects) {
				for await(const subject of candidate?.idealPositions?.teacher[type]?.subjects) {
					let subjectValue = null
					subjectValue = allSubjects?.find(s => s.id.toString() === subject)

					if (subjectValue) {
						subjects.push({label: t('subjects.'+subjectValue?.label), value: subjectValue?.id})
					}
				}
			}

			if (candidate?.idealPositions?.teacher[type]?.specialities) {
				for await(const speciality of candidate?.idealPositions?.teacher[type]?.specialities) {
					let specialityValue = null
					specialityValue = levels.find(s => s.id.toString() === speciality)
					
					if (specialityValue) {
						specialities.push({ label: t('levels.'+specialityValue?.level), value: specialityValue?.id })
					}
				}
			}
		}
		setTeacherFormState({
			minWage: candidate?.idealPositions ? candidate?.idealPositions?.teacher[type]?.minWage : null,
			movilityAvailability: candidate?.idealPositions ? candidate?.idealPositions?.teacher[type]?.movilityAvailability ? {label: t('profile.candidate.idealPosition.' + candidate?.idealPositions?.teacher[type]?.movilityAvailability), value: candidate?.idealPositions?.teacher[type]?.movilityAvailability} : null : null,
			desiredLocations: desiredLocations,
			subjects: subjects,
			specialities: specialities,
			workDay: candidate?.idealPositions ? candidate?.idealPositions?.teacher[type]?.workDay?.map((wd) => {return {label: t('profile.candidate.idealPosition.workDay.' + wd), value: wd}}): null,
			active: candidate?.idealPositions ? candidate?.idealPositions?.teacher[type]?.active : false
		})
		setActiveType(type)
	}

	const handleMobilityAvailabilityChange = (value) => {
		const temporalFormState = {
			...teacherFormState,
			movilityAvailability: value,
			desiredLocations: []
		}
		if (value.value === 'national') {
			setLocationOptions(provinces)
		}

		if (value.value === 'autonomous') {
			setLocationOptions(provinces.filter(p => p.parent_value === provinces?.find(p => p.value === towns[0]?.parent_value)?.parent_value))
		}

		if (value.value === 'provincial') {
			setLocationOptions(towns)
		}
		if (value.value === 'local') {
			setLocationOptions(towns.filter(p => p.value === candidate?.town))
			temporalFormState.desiredLocations = towns?.filter(p => p.value === candidate?.town)
		}
		setTeacherFormState(temporalFormState)
	}

	useEffect(() => {
		window.scrollTo({
			top: 0,
			behavior: 'instant',
		})
		if(client){
			dispatch(getCandidate(candidateId || client?.id))
			dispatch(getCandidateAvailableLevels(candidateId || client?.id))
			dispatch(getCandidateAvailableTowns(candidateId || client?.id))
			dispatch(getCandidateProvinces())
			dispatch(getCourseSubjects())
		}
	},[dispatch, t, client])

	useEffect(() => {
	    if(resultcandidate){
	        switch (resultcandidate) {
	            case 'updateStatusSuccess':
	                dispatch(getCandidate(candidateId || client?.id))
	                Swal.fire({
	                    showConfirmButton: true,
	                    showDenyButton: false,
	                    confirmButtonText: t('global.great'),
	                    icon: 'success',
	                    text: t('profile.candidate.idealPosition.updateStatusSuccess')
	                })
	                dispatch(getCandidateProfileStatus(candidateId || client?.id))
					dispatch({type: 'CANDIDATE_RESET_RESULT'})
	                break;
				case 'editIdealPositionTeacherSuccess':
					dispatch(getCandidate(candidateId || client?.id))
	                Swal.fire({
	                    showConfirmButton: true,
	                    showDenyButton: false,
	                    confirmButtonText: t('global.great'),
	                    icon: 'success',
	                    text: t('profile.candidate.idealPosition.updateSuccess')
	                })
	                dispatch(getCandidateProfileStatus(candidateId || client?.id))
					dispatch({type: 'CANDIDATE_RESET_RESULT'})
					setTeacherFormState({
						minWage: null,
						movilityAvailability: null,
						desiredLocations: [],
						subjects: [],
						specialities: [],
						workDay: []
					})
					setActiveType(null)
					break;
	            default:
	                break;
	        }
	    }
	// eslint-disable-next-line
	}, [resultcandidate, dispatch])

	return (
		<>
			<Container className='cuerpo'>
				<Row className='mb-4'>
					<Col className='d-flex align-items-center'>
						<img src="/images/idealPositionBig.svg" alt="Icono puesto ideal" />
						<h1 className='ms-2 m-0'>{t('menus.idealPosition')}</h1>
					</Col>
				</Row>
				<Row className="mt-2">
					<Col>
						<Card className='mb-5 sombra'>
							<Card.Body className='px-5 pt-5'>
								<Row className="mb-3">
									<Col>
										<h3>{t('profile.candidate.idealPosition.title')}</h3>
									</Col>
								</Row>
								<Row className='my-3'>
									<Col>
										<h4>{t('profile.candidate.idealPosition.functions')}: {t('profile.candidate.idealPosition.teacher')}</h4>
									</Col>
								</Row>
								<Row className='my-4'>
									<Col xs={12} lg={4} className='my-3'>
										<Card>
											<Card.Body>
												<div className='my-3'>
													<Card.Title>{t('profile.candidate.time-practice')}</Card.Title>
												</div>
												<div className='my-3'>
													<span className='fw-bold'>{t('profile.candidate.idealPosition.movilityAvailability')}</span>
													<div>
														<span>{t(`profile.candidate.${candidate?.idealPositions?.teacher?.practice?.movilityAvailability ? `idealPosition.${candidate?.idealPositions?.teacher?.practice?.movilityAvailability}` : 'undefined'}`)}</span>
													</div>
												</div>
												<div className='my-3'>
													<span className='fw-bold'>{t('profile.candidate.idealPosition.desiredLocations')}</span>
													<div >
														<span>
															{
																candidate?.idealPositions?.teacher?.practice?.desiredLocations?.length > 0
																	?
																	candidate?.idealPositions?.teacher?.practice?.desiredLocations?.map(location => candidate?.idealPositions?.teacher?.practice?.movilityAvailability === "autonomous" || candidate?.idealPositions?.teacher?.practice?.movilityAvailability === "national" ? provinces.find(p => p.value === location)?.label : towns.find(t => t.value === location)?.label).join(", ")
																	:
																		t('profile.candidate.undefined')
															}
														</span>
													</div>
												</div>
												<div className='my-3'>
													<span className='fw-bold'>{t('profile.candidate.idealPosition.minWage')}</span>
													<div>
														<span>{candidate?.idealPositions?.teacher?.practice?.minWage || t('profile.candidate.undefined')}</span>
													</div>
												</div>
												<div className='my-3'>
													<span className='fw-bold'>{t('profile.candidate.idealPosition.specialities')}</span>
													<div >
														<span>
															{
																candidate?.idealPositions?.teacher?.practice?.specialities?.length > 0
																	?
																		candidate?.idealPositions?.teacher?.practice?.specialities?.map(speciality => t('levels.'+levels.find(l => l.id.toString() === speciality)?.level)).join(", ")
																	:
																		t('profile.candidate.undefined')
															}
														</span>
													</div>
												</div>
												<div className='my-3'>
													<span className='fw-bold'>{t('profile.candidate.idealPosition.subjects')}</span>
													<div>
														<span>
															{
																candidate?.idealPositions?.teacher?.practice?.subjects?.length > 0
																	?
																		candidate?.idealPositions?.teacher?.practice?.subjects?.map(subject => t('subjects.'+allSubjects?.find(s => s.id?.toString() === subject)?.label)).join(", ")
																	:
																		t('profile.candidate.undefined')
															}
														</span>
													</div>
												</div>
												<div className='my-3'>
													<span className='fw-bold'>{t('profile.candidate.idealPosition.workDay.label')}</span>
													<div>
														<span>{candidate?.idealPositions?.teacher?.practice?.workDay?.length > 0 ? candidate?.idealPositions?.teacher?.practice?.workDay?.map(workDay => t(`profile.candidate.${workDay ? `idealPosition.workDay.${workDay}` : 'undefined'}`)).join(', ') : t('profile.candidate.undefined')}</span>
													</div>
												</div>
												<Row className='mt-5'>
													<Col xs={6} className='d-flex'>
														<Form.Check
															type="switch"
															name="switch"
															id="activeSwitch"
															onChange={({target}) => handleActiveSwitch(target.checked, 'practice')} 
															checked={candidate?.idealPositions?.teacher?.practice?.active || false}
														/>
														<span>
															{candidate?.idealPositions?.teacher?.practice?.active ? t('profile.candidate.idealPosition.active') : t('profile.candidate.idealPosition.inactive')}
														</span>
													</Col>
													<Col xs={6}>
														<Button variant='primary' type='button' onClick={() => {selectType('practice')}}>
															{t('global.edit')}
														</Button>
													</Col>
												</Row>
											</Card.Body>
										</Card>
									</Col>
									<Col xs={12} lg={4} className='my-3'>
										<Card>
											<Card.Body>
												<div className='my-3'>
													<Card.Title>{t('profile.candidate.time-substitution')}</Card.Title>
												</div>
												<div className='my-3'>
													<span className='fw-bold'>{t('profile.candidate.idealPosition.movilityAvailability')}</span>
													<div>
														<span>{t(`profile.candidate.${candidate?.idealPositions?.teacher?.substitution?.movilityAvailability ? `idealPosition.${candidate?.idealPositions?.teacher?.substitution?.movilityAvailability}` : 'undefined'}`)}</span>
													</div>
												</div>
												<div className='my-3'>
													<span className='fw-bold'>{t('profile.candidate.idealPosition.desiredLocations')}</span>
													<div>
														<span>
															{
																candidate?.idealPositions?.teacher?.substitution?.desiredLocations?.length > 0
																	?
																	candidate?.idealPositions?.teacher?.substitution?.desiredLocations?.map(location => candidate?.idealPositions?.teacher?.substitution?.movilityAvailability === "autonomous" || candidate?.idealPositions?.teacher?.substitution?.movilityAvailability === "national" ? provinces.find(p => p.value === location)?.label : towns.find(t => t.value === location)?.label).join(", ")
																	:
																		t('profile.candidate.undefined')
															}
														</span>
													</div>
												</div>
												<div className='my-3'>
													<span className='fw-bold'>{t('profile.candidate.idealPosition.minWage')}</span>
													<div>
														<span>{candidate?.idealPositions?.teacher?.substitution?.minWage || t('profile.candidate.undefined')}</span>
													</div>
												</div>
												<div className='my-3'>
													<span className='fw-bold'>{t('profile.candidate.idealPosition.specialities')}</span>
													<div>
														<span>
															{
																candidate?.idealPositions?.teacher?.substitution?.specialities?.length > 0
																	?
																		candidate?.idealPositions?.teacher?.substitution?.specialities?.map(speciality => t('levels.'+levels?.find(l => l.id?.toString() === speciality)?.level)).join(", ")
																	:
																		t('profile.candidate.undefined')
															}
														</span>
													</div>
												</div>
												<div className='my-3'>
													<span className='fw-bold'>{t('profile.candidate.idealPosition.subjects')}</span>
													<div>
														<span>
															{
																candidate?.idealPositions?.teacher?.substitution?.subjects?.length > 0
																	?
																		candidate?.idealPositions?.teacher?.substitution?.subjects?.map(subject => t('subjects.'+allSubjects?.find(s => s.id?.toString() === subject)?.label)).join(", ")
																	:
																		t('profile.candidate.undefined')
															}
														</span>
													</div>
												</div>
												<div className='my-3'>
													<span className='fw-bold'>{t('profile.candidate.idealPosition.workDay.label')}</span>
													<div>
														<span>{candidate?.idealPositions?.teacher?.substitution?.workDay?.length > 0 ? candidate?.idealPositions?.teacher?.substitution?.workDay?.map(workDay => t(`profile.candidate.${workDay ? `idealPosition.workDay.${workDay}` : 'undefined'}`)).join(', ') : t('profile.candidate.undefined')}</span>
													</div>
												</div>
												<Row className='mt-5'>
													<Col xs={6} className='d-flex'>
														<Form.Check
															type="switch"
															name="switch"
															id="activeSwitch"
															onChange={({target}) => handleActiveSwitch(target.checked, 'substitution')} 
															checked={candidate?.idealPositions?.teacher?.substitution?.active || false}
														/>
														<span>
															{candidate?.idealPositions?.teacher?.substitution?.active ? t('profile.candidate.idealPosition.active') : t('profile.candidate.idealPosition.inactive')}
														</span>
													</Col>
													<Col xs={6}>
														<Button variant='primary' type='button' onClick={() => {selectType('substitution')}}>
															{t('global.edit')}
														</Button>
													</Col>
												</Row>
											</Card.Body>
										</Card>
									</Col>
									<Col xs={12} lg={4} className='my-3'>
										<Card>
											<Card.Body>
												<div className='my-3'>
													<Card.Title>{t('profile.candidate.time-work')}</Card.Title>
												</div>
												<div className='my-3'>
													<span className='fw-bold'>{t('profile.candidate.idealPosition.movilityAvailability')}</span>
													<div>
														<span>{t(`profile.candidate.${candidate?.idealPositions?.teacher?.work?.movilityAvailability ? `idealPosition.${candidate?.idealPositions?.teacher?.work?.movilityAvailability}` : 'undefined'}`)}</span>
													</div>
												</div>
												<div className='my-3'>
													<span className='fw-bold'>{t('profile.candidate.idealPosition.desiredLocations')}</span>
													<div>
														<span>
															{
																candidate?.idealPositions?.teacher?.work?.desiredLocations?.length > 0
																	?
																	candidate?.idealPositions?.teacher?.work?.desiredLocations?.map(location => candidate?.idealPositions?.teacher?.work?.movilityAvailability === "autonomous" || candidate?.idealPositions?.teacher?.work?.movilityAvailability === "national" ? provinces.find(p => p.value === location)?.label : towns.find(t => t.value === location)?.label).join(", ")
																	:
																		t('profile.candidate.undefined')
															}
														</span>
													</div>
												</div>
												<div className='my-3'>
													<span className='fw-bold'>{t('profile.candidate.idealPosition.minWage')}</span>
													<div>
														<span>{candidate?.idealPositions?.teacher?.work?.minWage || t('profile.candidate.undefined')}</span>
													</div>
												</div>
												<div className='my-3'>
													<span className='fw-bold'>{t('profile.candidate.idealPosition.specialities')}</span>
													<div>
														<span>
															{
																candidate?.idealPositions?.teacher?.work?.specialities?.length > 0
																	?
																		candidate?.idealPositions?.teacher?.work?.specialities?.map(speciality => t('levels.'+levels?.find(l => l.id.toString() === speciality)?.level)).join(", ")
																	:
																		t('profile.candidate.undefined')
															}
														</span>
													</div>
												</div>
												<div className='my-3'>
													<span className='fw-bold'>{t('profile.candidate.idealPosition.subjects')}</span>
													<div>
														<span>
															{
																candidate?.idealPositions?.teacher?.work?.subjects?.length > 0
																	?
																		candidate?.idealPositions?.teacher?.work?.subjects?.map(subject => t('subjects.'+ allSubjects?.find(s => s.id.toString() === subject)?.label)).join(", ")
																	:
																		t('profile.candidate.undefined')
															}
														</span>
													</div>
												</div>
												<div className='my-3'>
													<span className='fw-bold'>{t('profile.candidate.idealPosition.workDay.label')}</span>
													<div>
														<span>{candidate?.idealPositions?.teacher?.work?.workDay?.length > 0 ? candidate?.idealPositions?.teacher?.work?.workDay?.map(workDay => t(`profile.candidate.${workDay ? `idealPosition.workDay.${workDay}` : 'undefined'}`)).join(', ') : t('profile.candidate.undefined')}</span>
													</div>
												</div>
												<Row className='mt-5'>
													<Col xs={6} className='d-flex'>
														<Form.Check
															type="switch"
															name="switch"
															id="activeSwitch"
															onChange={({target}) => handleActiveSwitch(target.checked, 'work')} 
															checked={candidate?.idealPositions?.teacher?.work?.active || false}
														/>
														<span>
															{candidate?.idealPositions?.teacher?.work?.active ? t('profile.candidate.idealPosition.active') : t('profile.candidate.idealPosition.inactive')}
														</span>
													</Col>
													<Col xs={6}>
														<Button variant='primary' type='button' onClick={() => {selectType('work')}}>
															{t('global.edit')}
														</Button>
													</Col>
												</Row>
											</Card.Body>
										</Card>
									</Col>
								</Row>
							</Card.Body>
						</Card>
					</Col>
				</Row>
			</Container>
			<Modal show={activeType !== null ? true : false} onHide={() => {setActiveType(null); setLocationOptions([])}}>
				<Modal.Header closeButton>
					<Modal.Title>{t('profile.candidate.time-' + activeType)}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<Form onSubmit={handleSubmit}>
							<Row className='my-4'>
								<Col xs={12}>
									<Form.Label>{t('profile.candidate.idealPosition.movilityAvailability')}</Form.Label>
									<Select
										options={[
											{label: t('profile.candidate.idealPosition.local'), value: 'local'},
											{label: t('profile.candidate.idealPosition.provincial'), value: 'provincial'},
											{label: t('profile.candidate.idealPosition.autonomous'), value: 'autonomous'},
											{label: t('profile.candidate.idealPosition.national'), value: 'national'}
										]}
										value={teacherFormState.movilityAvailability}
										onChange={handleMobilityAvailabilityChange}
									/>
								</Col>
							</Row>
							<Row className='my-4'>
								<Col xs={12}>
									<Form.Label>{t('profile.candidate.idealPosition.desiredLocations')}</Form.Label>
									<Select
										options={locationOptions}
										value={teacherFormState.desiredLocations}
										isMulti
										onChange={selectedValues => setTeacherFormState({...teacherFormState, desiredLocations: selectedValues})}
									/>
								</Col>
							</Row>
							<Row className='my-4'>
								<Col xs={12}>
									<Form.Label className='me-2'>{t('profile.candidate.idealPosition.minWage')}</Form.Label> 
									<OverlayTrigger placement='bottom' overlay={<Tooltip>{t('profile.candidate.idealPosition.minWageInfo')}</Tooltip>}>
										<i className='fas fa-question-circle'/>
									</OverlayTrigger>
									<Form.Control type='number' placeholder={t('profile.candidate.idealPosition.minWagePlaceholder')} value={teacherFormState.minWage || ''} onChange={({target}) => setTeacherFormState({...teacherFormState, minWage: target.value})}/>
								</Col>
							</Row>
							<Row className='my-4'>
								<Col xs={12}>
									<Form.Label>{t('profile.candidate.idealPosition.specialities')}</Form.Label>
									<Select
										options={levels.map(level => {
											return { label: t('levels.'+level.level), value: level.id }
										})}
										value={teacherFormState.specialities}
										onChange={changeSpecialities}
										isMulti
									/>
								</Col>
							</Row>
							<Row className='my-4'>
								<Col xs={12}>
									<Form.Label>{t('profile.candidate.idealPosition.subjects')}</Form.Label>
									<Select
										options={subjects.map(subject => {
											return { ...subject, label: t('subjects.'+subject.subject), value: subject.id }
										})}
										value={teacherFormState.subjects}
										onChange={changeSubjects}
										isMulti
									/>
								</Col>
							</Row>
							<Row className='my-4'>
								<Col xs={12}>
									<Form.Label>{t('profile.candidate.idealPosition.workDay.label')}</Form.Label>
									<Select
										options={['full', 'half', 'partial'].map(workDay => {return {label: t('profile.candidate.idealPosition.workDay.' + workDay), value: workDay}})}
										value={teacherFormState.workDay}
										onChange={selectedValues => setTeacherFormState({...teacherFormState, workDay: selectedValues})}
										isMulti
									/>
								</Col>
							</Row>
							<Row className='my-4'>
								<Col xs={12} className='d-flex justify-content-end'>
									<Button type='submit' variant='primary' className='px-5'>{t('global.save')}</Button>
								</Col>
							</Row>
						</Form>
				</Modal.Body>
			</Modal>
			<Loading show={loading || miscellaneousLoading}/>
		</>
	)
}
